export default {
  filter: 'Filter',
  resize: 'Resize',
  expand: 'Expand',
  duplicate: 'Duplicate',
  remove: 'Remove',
  averageTime: 'Average time',
  atTime: 'at',
  weekOf: 'Week of',
};
